import { LeaveChatRoomRequest, EmptyResponse } from '~/types';
import { fetcher } from './config/fetcher';
import http from './config/http';

export const leaveChatRoom = async ({ chatroom_id }: LeaveChatRoomRequest) => {
  return fetcher(() => http.delete<EmptyResponse>(`/chatrooms/${chatroom_id}`));
};
